import { type FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FormFeedback } from '../../components/Form/FormFeedback'
import { SeatPurchaseSummary } from './SeatPurchaseSummary'
import { type BuySeatState } from './useBuySeat'

export interface BuySeatStepProps {
  firstLine: string
  secondLine: string
  buy: BuySeatState
}

export const BuySeatStep: FC<BuySeatStepProps> = ({ firstLine, secondLine, buy }) => (
  <Container>
    <Row>
      <Col className='p-0'>
        <div className='paragraph-medium'>{firstLine}</div>
        <div className='paragraph-medium pb-2'>{secondLine}</div>
        <SeatPurchaseSummary preview={buy.preview} />
        <div className='paragraph-small zocks-text-gray-600 pt-3'>
          You can also manage your seats on the{' '}
          <Link to='/account/plan' className='zocks-text-primary'>
            Plan page
          </Link>
          .
        </div>
        {buy.error ? <FormFeedback>{buy.error}</FormFeedback> : null}
      </Col>
    </Row>
  </Container>
)
